<template>
  <div id="charges" class="col-12 p-0">
    <div class="row-center">
      <div>
        <!-- CREAR -->

        <!-- 1 MODAL CREACIÓN CARGO -->

        <b-modal id="modal-create-ch" hide-footer centered>
          <div class="col-12 d-flex flex-column align-items-center">
            <h2 class="text-uppercase font-weight-bold">agregar Cargo</h2>
            <input
              v-model="nameLN"
              type="text"
              class="form-control mt-5 input-vp2"
              placeholder="Nombre del Cargo"
            />
            <v-select
              class="mt-3 col-12 p-0"
              label="name"
              v-model="selectedGch"
              :options="services.section"
            />
            <b-form-select
              class="mt-3"
              v-model="selectedch"
              :options="optionsch"
              @change="getRoles"
            ></b-form-select>
            <b-form-select
              v-if="checkRoles"
              class="mt-3"
              v-model="selectedR"
              :options="optionsR"
            ></b-form-select>
            <b-form-select
              v-if="
                (scenarios.data ? scenarios.data[0] : false) &&
                selectedch.name !== 'default' &&
                selectedch.categoria_padre_id == 1
              "
              class="mt-3"
              v-model="selectedZ"
              :options="optionsZ"
            ></b-form-select>
            <b-form-group
              label="¿Este cargo estará en periodo de entrenamiento?"
              v-slot="{ ariaDescribedby }"
              class="mt-4 mb-0 fs-6 col-12 p-0"
              style="font-size: 14px; text-align: left"
            >
              <b-form-group>
                <b-form-radio
                  class="col-4"
                  style="font-size: 16px"
                  v-model="training"
                  :aria-describedby="ariaDescribedby"
                  name="some-radios"
                  value="true"
                  inline
                  >Si</b-form-radio
                >
                <b-form-radio
                  class="col-4"
                  style="font-size: 16px"
                  v-model="training"
                  :aria-describedby="ariaDescribedby"
                  name="some-radios"
                  value="false"
                  inline
                  >No</b-form-radio
                >
              </b-form-group>
            </b-form-group>
            <div v-if="loading" class="loaderSmall"></div>

            <div style="display: flex" class="mt-2">
              <button
                v-if="!loading"
                :disabled="
                  nameLN === '' ||
                  selectedch.name === 'default' ||
                  selectedGch.name == 'Selecciona un grupo de Cargos' ||
                  selectedR.id == null ||
                  training == null
                "
                @click="nextStep1CH('next')"
                type="button"
                class="button-primary enviar-mensaje mr-4 pt-1 pb-1"
                style="border: none"
              >
                <span class="cta">Guardar Cambios</span>
              </button>
              <button
                type="button"
                class="button-secundary ml-4"
                style="margin: auto"
                @click="$bvModal.hide('modal-create-ch')"
              >
                <span class="cta">Cancelar</span>
              </button>
            </div>
          </div>
        </b-modal>

        <!-- 2 MODAL CREACIÓN CARGO -->

        <b-modal id="modal-create2-ch" hide-footer centered>
          <div class="col-12 d-flex flex-column align-items-center">
            <img
              class="centerImg1"
              src="@/assets/images/icons/warning_.svg"
              width="15%"
            />
            <h3 class="pt-5 font-weight-bold">
              ¿Estás seguro de guardar este Cargo?
            </h3>
            <p class="pt-5">
              <span class="text-uppercase font-weight-bold">Cargo: </span>
              {{ nameLN }}
            </p>
            <p v-if="training == 'true'" class="mb-4">
              <span class="text-uppercase" style="color: #ff6700"
                >Cargo de entrenamiento</span
              >
            </p>
            <p v-if="selectedch.id" style="font-size: 16px">
              <span class="font-weight-bold">Grupo del Cargo: </span
              >{{ selectedGch.name }}
            </p>
            <p v-if="selectedch.id" style="font-size: 16px">
              <span class="font-weight-bold">Linea de Negocio: </span
              >{{ selectedch.name }}
            </p>
            <p v-if="selectedZ.id" style="font-size: 16px">
              <span class="font-weight-bold">Escenario: </span
              >{{ selectedZ.name }}
            </p>
            <p v-if="selectedR.id" style="font-size: 16px">
              <span class="font-weight-bold">Rol en la plataforma: </span
              >{{ selectedR.name }}
            </p>

            <div style="display: flex" class="pt-2">
              <button
                type="button"
                class="button-secundary mr-4"
                style="margin: auto"
                @click="nextStep1CH('previous')"
              >
                <span class="cta" style="width: 100%">Seguir editando</span>
              </button>
              <button
                @click="nextStep1CH('save')"
                type="button"
                class="button-primary enviar-mensaje ml-4"
                style="border: none"
              >
                <span class="cta" style="width: 100%">Guardar cambios</span>
              </button>
            </div>
          </div>
        </b-modal>

        <!-- 3 MODAL CREACIÓN CARGO -- EXITOSO  -->

        <b-modal id="modal-success" hide-footer centered>
          <div class="col-12 d-flex flex-column align-items-center">
            <img
              class="centerImg1"
              src="@/assets/images/icons/checkbox-circle-line.svg"
            />
            <h3 class="pt-5 font-weight-bold">¡Proceso exitoso!</h3>
            <p class="pt-5">{{ message.message }}</p>
            <button
              @click="$bvModal.hide('modal-success')"
              type="button"
              class="button-primary enviar-mensaje"
              style="border: none"
            >
              <span class="cta" style="width: 100%">Entendido</span>
            </button>
          </div>
        </b-modal>

        <!-- 3 MODAL FALLO DE OPERACIÓN -- FALLIDO -->

        <b-modal v-if="error.message" id="modal-fail" hide-footer centered>
          <div class="col-12 d-flex flex-column align-items-center">
            <img
              class="centerImg1"
              src="@/assets/images/icons/close.svg"
              width="20%"
            />
            <h3 class="pt-5 font-weight-bold">¡Proceso fallido!</h3>
            <p class="pt-5">{{ error.message }}</p>
            <button
              class="mt-5 mb-5 col-6 btn btn-danger"
              @click="$bvModal.hide('modal-fail')"
            >
              Entendido
            </button>
          </div>
        </b-modal>

        <!-- EDITAR/ELIMINAR -->

        <!-- 1 MODAL EDICIÓN CARGO -->

        <b-modal id="modal-edit-ch" hide-footer centered>
          <div class="col-12 d-flex flex-column align-items-center">
            <h2 class="text-uppercase font-weight-bold">Editar Cargo</h2>
            <input
              v-model="nameLN"
              type="text"
              class="form-control mt-5 input-vp2"
              placeholder="Nombre del Cargo"
            />
            <v-select
              class="mt-3 col-12 p-0"
              label="name"
              v-model="selectedGch"
              :options="services.section"
            />
            <b-form-select
              class="mt-3"
              v-model="selectedch"
              :options="optionsch"
              @change="getRoles"
            ></b-form-select>
            <b-form-select
              v-if="checkRoles"
              class="mt-3"
              v-model="selectedR"
              :options="optionsR"
            ></b-form-select>
            <b-form-select
              v-if="
                (scenarios.data ? scenarios.data[0] : false) &&
                selectedch.name !== 'default' &&
                selectedch.categoria_padre_id == 1
              "
              class="mt-3"
              v-model="selectedZ"
              :options="optionsZ"
            ></b-form-select>
            <b-form-group
              label="¿Este cargo estará en periodo de entrenamiento?"
              v-slot="{ ariaDescribedby }"
              class="mt-4 mb-0 fs-6 col-12 p-0"
              style="font-size: 14px; text-align: left"
            >
              <b-form-group>
                <b-form-radio
                  class="col-4"
                  style="font-size: 16px"
                  v-model="training"
                  :aria-describedby="ariaDescribedby"
                  name="some-radios"
                  value="true"
                  inline
                  >Si</b-form-radio
                >
                <b-form-radio
                  class="col-4"
                  style="font-size: 16px"
                  v-model="training"
                  :aria-describedby="ariaDescribedby"
                  name="some-radios"
                  value="false"
                  inline
                  >No</b-form-radio
                >
              </b-form-group>
            </b-form-group>
            <div v-if="loading" class="loaderSmall"></div>

            <div style="display: flex" class="mt-4">
              <button
                v-if="!loading"
                :disabled="
                  nameLN === '' ||
                  selectedch.name === 'default' ||
                  selectedGch.name == 'Selecciona un grupo de Cargos' ||
                  ((scenarios.data ? scenarios.data[0] : false) &&
                  selectedch.categoria_padre_id == 1
                    ? selectedZ.name == 'default'
                    : false) ||
                  selectedR.id == null ||
                  training == null
                "
                @click="nextStep2CH('next')"
                type="button"
                class="button-primary enviar-mensaje mr-4"
                style="border: none"
              >
                <span class="cta">Guardar Cambios</span>
              </button>
              <button
                class="delete button-primary enviar-mensaje ml-4"
                type="button"
                @click="nextStep2CH('nextD')"
              >
                <img src="@/assets/images/icons/delete_trash_white.svg" />
                <span class="cta ml-2"> Borrar Cargo</span>
              </button>
            </div>
          </div>
        </b-modal>

        <!-- 2 MODAL EDICIÓN CARGO -->

        <b-modal id="modal-edit2-ch" hide-footer centered>
          <div class="col-12 d-flex flex-column align-items-center">
            <img
              class="centerImg1 mb-4"
              src="@/assets/images/icons/warning_.svg"
              width="15%"
            />
            <h3 class="pt-5 font-weight-bold">
              ¿Estás seguro de modificar este Cargo?
            </h3>
            <p class="pt-5">
              <span class="font-weight-bold"> Cargo: </span>
              <span class="text-uppercase">
                {{ nameLN }}
              </span>
            </p>
            <p v-if="training == true" class="mb-4">
              <span class="text-uppercase" style="color: #ff6700"
                >Cargo de entrenamiento</span
              >
            </p>
            <p v-if="selectedch.id" style="font-size: 16px">
              <span class="font-weight-bold">Grupo de Cargos: </span
              >{{ selectedGch.name }}
            </p>
            <p v-if="selectedch.id" style="font-size: 16px">
              <span class="font-weight-bold">Lineas de Negocio: </span
              >{{ selectedch.name }}
            </p>
            <p v-if="selectedZ.id" style="font-size: 16px">
              <span class="font-weight-bold">Escenario: </span
              >{{ selectedZ.name }}
            </p>
            <p v-if="selectedR.id" style="font-size: 16px">
              <span class="font-weight-bold">Rol: </span>{{ selectedR.name }}
            </p>
            <div style="width: 100%; display: flex; margin-top: 32px">
              <button
                type="button"
                class="button-secundary"
                style="margin: auto"
                @click="nextStep2CH('previous')"
              >
                <span class="cta" style="width: 100%">Seguir editando</span>
              </button>
              <button
                @click="nextStep2CH('edit')"
                type="button"
                class="button-primary enviar-mensaje"
                style="border: none"
              >
                <span class="cta" style="width: 100%">Guardar cambios</span>
              </button>
            </div>
          </div>
        </b-modal>

        <!-- 4 MODAL ELIMINAR CARGO -->

        <b-modal id="modal-delete-ch" hide-footer centered>
          <div class="col-12 d-flex flex-column align-items-center">
            <img
              class="centerImg1 mb-4"
              src="@/assets/images/icons/warning_.svg"
              width="15%"
            />
            <h3 class="pt-4 font-weight-bold">
              ¿Estás seguro de eliminar el Cargo?
            </h3>
            <p class="pt-2 text-danger">
              Al confirmar no podrás recuperar los cambios.
            </p>
            <p class="pt-2">
              <span class="text-uppercase">{{ nameLN }}</span>
            </p>
            <div style="display: flex" class="mt-4">
              <button
                type="button"
                class="button-secundary mr-4"
                style="margin: auto"
                @click="nextStep2CH('previous')"
              >
                <span class="cta">No borrar</span>
              </button>
              <button
                class="delete button-primary enviar-mensaje ml-4"
                type="button"
                @click="nextStep2CH('delete')"
              >
                <img
                  src="@/assets/images/icons/delete_trash_white.svg"
                  alt=""
                />
                <span class="cta ml-2"> Borrar Cargo</span>
              </button>
            </div>
          </div>
        </b-modal>
      </div>
    </div>
    <div class="row">
      <SelectSettings />
      <!-- Boton Crear Cargo -->
      <div class="col-lg-4 col-sm-12 mt-4">
        <AddCategory text="Agregar Cargo +" @nuevo="create"></AddCategory>
      </div>
    </div>
    <div class="row">
      <div class="col-md-8 col-sm-12">
        <div class="mb-4 card-personalizada">
          <div class="card-header card-header-left">
            <h3 style="color:color: #263238;">Lista de Cargos</h3>
          </div>
          <div class="col-12">
            <div class="buscar-empleado mt-4 mb-4">
              <div class="input-group-prepend">
                <span class="icon icon-search1"></span>
              </div>
              <input
                type="search"
                placeholder="Buscar Cargo"
                aria-label="Buscar Cargo"
                autocomplete="off"
                class="form-control body_regular"
                v-model="filter"
                style="border: 0px"
                @keydown="startTipyng()"
                @keyup="finishTipyng()"
              />
            </div>
          </div>
          <div class="mt-5" v-if="loading" id="loader"></div>
          <div v-else class="col-12 ml-1 mt-2 mb-1 mr-2">
            <datatable
              :columns="datatable.columns"
              :data="datatable.rows"
              :filter="datatable.filter"
              :per-page="datatable.perPage"
              :page="datatable.page"
              class="col-12 mt-5 table table-hover table-borderless"
            >
              <template slot-scope="{ row, columns }">
                <tr @click="editCharge(row)">
                  <template>
                    <datatable-cell
                      v-for="(column, j) in columns"
                      :key="j"
                      :column="column"
                      :row="row"
                    >
                    </datatable-cell>
                  </template>
                </tr>
              </template>
            </datatable>
            <div
              class="col-12 cont-pagination my-5 d-flex justify-content-center"
            >
              <Pagination
                :data="charges.data"
                :limit="10"
                @pagination-change-page="getCharges"
              >
                <template #prev-nav>
                  <span>&lt;</span>
                </template>
                <template #next-nav>
                  <span>&gt;</span>
                </template>
              </Pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import Pagination from "laravel-vue-pagination";
import SelectSettings from "@/components/platformSettings/selectSettings.vue";
import AddCategory from "@/components/core/button/add-category.vue";
export default {
  name: "LineBusiness",
  components: { Pagination, SelectSettings, AddCategory },
  data() {
    return {
      runTime: "",
      selectedch: {
        name: "default",
        pro_line_deals: null,
        categoria_padre_id: 0,
      },
      optionsch: [
        {
          value: {
            name: "default",
            pro_line_deals: null,
            categoria_padre_id: 0,
          },
          text: "Asigna una categoria",
        },
      ],
      selectedZ: { name: "default", id: null },
      optionsZ: [
        { value: { name: "default", id: null }, text: "Asigna un escenario" },
      ],
      selectedR: { name: "default", id: null },
      optionsR: [
        {
          value: { name: "default", id: null },
          text: "Asigna un Rol en la plataforma",
        },
      ],
      selectedGch: { name: "Selecciona un grupo de Cargos" },
      training: false,
      checkRoles: false,
      indexRow: 0,
      nameLN: "",
      modalCreateNew: "",
      filter: "",
      datatable: {
        total: 18,
        perPage: 10,
        last_page: 2,
        page: 1,
        columns: [],
        rows: [],
      },
    };
  },
  beforeMount() {
    this.getCharges();
  },
  computed: {
    ...mapState("modPlatformSettings", [
      "roles",
      "charges",
      "charge",
      "scenarios",
      "services",
      "loading",
      "error",
      "message",
    ]),

    checkEdit: function () {
      return this.nameLN === "";
    },
  },
  methods: {
    ...mapActions("modPlatformSettings", [
      "actGetRoles",
      "actCharges",
      "actCharge",
      "actScenariosByLd",
      "actServices",
      "actSaveCharge",
      "actUpdateCharge",
      "actDeleteCharge",
    ]),
    startTipyng() {
      clearTimeout(this.runTime);
    },
    finishTipyng() {
      this.runTime = setTimeout(() => {
        this.getCharges();
      }, 1500);
    },
    create() {
      (this.training = null), (this.nameLN = "");
      this.selectedch = {
        name: "default",
        pro_line_deals: null,
        categoria_padre_id: 0,
      };
      (this.selectedZ = { name: "default", id: null }),
        (this.selectedR = { name: "default", id: null }),
        (this.selectedGch = { name: "Selecciona un grupo de Cargos" });
      this.$root.$emit("bv::show::modal", "modal-create-ch");
    },

    nextStep1CH(x) {
      let data = {
        name: this.nameLN,
        category_type: this.selectedch.categoria_padre_id == 1 ? "ld" : "sb",
        pro_category_id: this.selectedch.id,
        pro_section_id: this.selectedGch.id,
        pro_scene_id:
          this.selectedch.categoria_padre_id == 1 ? this.selectedZ.id : null,
        core_role_id: this.selectedR.id,
        training: this.training == "false" ? false : true,
      };
      switch (x) {
        case "next":
          console.log("next");
          this.$root.$emit("bv::hide::modal", "modal-create-ch");
          this.$root.$emit("bv::show::modal", "modal-create2-ch");
          break;
        case "previous":
          this.$root.$emit("bv::hide::modal", "modal-create2-ch");
          this.$root.$emit("bv::show::modal", "modal-create-ch");
          break;
        case "save":
          this.actSaveCharge(data).then(() => {
            if (this.error.message) {
              this.$root.$emit("bv::hide::modal", "modal-create2-ch");
              this.$root.$emit("bv::show::modal", "modal-fail");
              this.getCharges();
            } else {
              this.nameLN = "";
              this.selectedsc = { name: "default", pro_line_deals: 0 };
              this.optionssc = [
                { value: null, text: "Asigna una linea de Negocio" },
              ];
              this.$root.$emit("bv::hide::modal", "modal-create2-ch");
              this.$root.$emit("bv::show::modal", "modal-success");
              this.getCharges();
            }
          });
          break;
        default:
      }
    },
    loadRows() {
      this.datatable = {
        total: 18,
        filter: "",
        perPage: 10,
        last_page: 2,
        page: 1,
        columns: [],
        rows: [],
      };
      this.datatable.columns = [
        {
          label: "Cargo",
          field: "name",
          align: "left",
          headerClass: "theading",
        },
        {
          label: "Categoría",
          field: "category",
          align: "left",
          headerClass: "theading",
          interpolate: true,
        },
      ];
    },
    getRoles(id) {
      this.checkRoles = false;
      this.actGetRoles().then(() => {
        this.checkRoles = true;
        if (this.selectedch.categoria_padre_id == 1) {
          if (this.selectedch.id == 3) {
            let charge = this.roles.filter((role) => role.id == 16);
            this.pushCharges(charge, id);
            return;
          } else {
            let charge = this.roles.filter(
              (role) => role.id == 16 || role.id == 11
            );
            this.pushCharges(charge, id);
            return;
          }
        } else if (this.selectedch.categoria_padre_id == 3) {
          let charge = this.roles.filter(
            (role) => role.id == 13 || role.id == 14
          );
          this.pushCharges(charge, id);
          return;
        } else {
          this.pushCharges(this.roles, id);
        }
      });
    },
    pushCharges(arrayRoles, id) {
      (this.optionsR = [
        {
          value: { name: "default", id: null },
          text: "Asigna un Rol en la plataforma",
          disabled: true,
        },
      ]),
        arrayRoles.forEach((x) => {
          this.optionsR.push({
            value: {
              id: x.id,
              name: x.name,
            },
            text: x.name,
          });
        });
      if (id) {
        let rol = this.optionsR.filter((x) => x.value.id == id);
        this.selectedR = rol[0].value;
      }
    },
    getCharges(page = 1) {
      this.optionsch = [
        {
          value: {
            name: "default",
            pro_line_deals: null,
            categoria_padre_id: 0,
          },
          text: "Asigna una categoria",
        },
      ];
      this.actServices().then(() => {
        let line_deals = [];
        let support_bags = [];
        this.services.line_deal.forEach((x) => {
          line_deals.push({
            value: {
              id: x.id,
              name: x.name,
              categoria_padre_id: 1,
            },
            text: x.name,
          });
        });
        this.services.support_bag.forEach((x) => {
          support_bags.push({
            value: {
              id: x.id,
              name: x.name,
              categoria_padre_id: 2,
            },
            text: x.name,
          });
        });
        let withOutTip = [
          {
            value: {
              id: null,
              name: "Personal Sin Propina",
              categoria_padre_id: 3,
            },
            text: "Personal Sin Propina",
          },
        ];
        this.optionsch.push(
          {
            label: "Lineas de Negocio",
            options: line_deals,
          },
          {
            label: "Bolsas de Apoyo",
            options: support_bags,
          },
          {
            label: "Personal Sin Propina",
            options: withOutTip,
          }
        );
      });

      let data = {};
      data = {
        page: page,
        filter: this.filter,
      };
      this.datatable.rows = [];
      this.actCharges(data).then(() => {
        this.loadRows();
        this.charges.data.data.forEach((x) => {
          if (x.category_type == "ld" && x.pro_category_id) {
            this.services.line_deal.forEach((y) => {
              if (y.id == x.pro_category_id) {
                this.datatable.rows.push({
                  id: x.id,
                  name: x.name,
                  category: y.name,
                });
              }
            });
          } else if (x.category_type == "sb" && x.pro_category_id) {
            this.services.support_bag.forEach((y) => {
              if (y.id == x.pro_category_id) {
                this.datatable.rows.push({
                  id: x.id,
                  name: x.name,
                  category: y.name,
                });
              }
            });
          } else {
            this.datatable.rows.push({
              id: x.id,
              name: x.name,
              category: "Sin Asignar",
            });
          }
        });
      });
    },
    getScenarios() {
      this.selectedZ = { name: "default", id: null };
      this.optionsZ = [
        { value: { name: "default", id: null }, text: "No aplica" },
      ];
      if (this.selectedch.categoria_padre_id == 1) {
        this.actScenariosByLd(this.selectedch.id).then(() => {
          this.scenarios.data.forEach((x) => {
            this.optionsZ.push({
              value: { name: x.name, id: x.id },
              text: x.name,
            });
          });
          if (this.charge.pro_scene_id) {
            this.optionsZ.forEach((x) => {
              if (x.value.id == this.charge.pro_scene_id) {
                this.selectedZ = x.value;
              }
            });
          }
        });
      }
    },

    editCharge(row) {
      this.actCharge(row.id).then(() => {
        this.nameLN = this.charge.name;
        this.training = this.charge.training == 0 ? "false" : "true";
        this.services.section.forEach((x) => {
          if (x.id == this.charge.pro_section_id) {
            this.selectedGch = x;
          }
        });
        if (this.charge.category_type == "ld") {
          this.optionsch[1].options.forEach((x) => {
            if (x.value.id == this.charge.pro_category_id) {
              this.selectedch = x.value;
              this.getScenarios();
            }
          });
        } else if (this.charge.category_type == "sb") {
          this.optionsch[2].options.forEach((x) => {
            if (x.value.id == this.charge.pro_category_id) {
              this.selectedch = x.value;
            }
          });
        }
        this.getRoles(this.charge.core_role_id);
        this.$root.$emit("bv::show::modal", "modal-edit-ch");
      });
    },
    nextStep2CH(x) {
      let data = {
        name: this.nameLN,
        category_type: this.selectedch.categoria_padre_id == 1 ? "ld" : "sb",
        pro_category_id: this.selectedch.id,
        pro_section_id: this.selectedGch.id,
        pro_scene_id:
          this.selectedch.categoria_padre_id == 1 ? this.selectedZ.id : null,
        core_role_id: this.selectedR.id,
        training: this.training == "false" ? false : true,
        id: this.charge.id,
      };
      switch (x) {
        case "next":
          this.$root.$emit("bv::hide::modal", "modal-edit-ch");
          this.$root.$emit("bv::show::modal", "modal-edit2-ch");
          break;
        case "previous":
          this.$root.$emit("bv::hide::modal", "modal-edit2-ch");
          this.$root.$emit("bv::hide::modal", "modal-delete-ch");
          this.$root.$emit("bv::show::modal", "modal-edit-ch");
          break;
        case "edit":
          this.actUpdateCharge(data).then(() => {
            if (this.error.message) {
              this.nameLN = "";
              this.selectedsc = { name: "default", pro_line_deals: 0 };
              this.$root.$emit("bv::hide::modal", "modal-edit2-ch");
              this.$root.$emit("bv::show::modal", "modal-fail");
              this.getCharges();
              return;
            } else {
              this.nameLN = "";
              this.selectedsc = { name: "default", pro_line_deals: 0 };
              this.$root.$emit("bv::hide::modal", "modal-edit2-ch");
              this.$root.$emit("bv::show::modal", "modal-success");
              this.getCharges();
            }
          });
          break;
        case "nextD":
          this.$root.$emit("bv::hide::modal", "modal-edit-ch");
          this.$root.$emit("bv::show::modal", "modal-delete-ch");
          break;
        case "delete":
          this.actDeleteCharge(this.charge.id).then(() => {
            if (this.error.message) {
              this.$root.$emit("bv::hide::modal", "modal-delete-ch");
              this.$root.$emit("bv::show::modal", "modal-fail");
              this.getCharges();
            } else {
              this.nameLN = "";
              this.selectedlb = [];
              this.$root.$emit("bv::hide::modal", "modal-delete-ch");
              this.$root.$emit("bv::show::modal", "modal-success");
              this.getCharges();
            }
          });
          break;
        default:
      }
    },
    getFilterDp(page = 1) {
      /*let data2 = [];
            data2 = {
                    'page':page,
                    };*/
      this.getCharges(page);
    },
  },
};
</script>
<style lang="scss">
#charges {
  .buscar-empleado {
    /* Auto layout */

    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 8px 12px;

    position: relative;
    width: 428px !important;
    height: 44px;
    //left: 30px;
    top: calc(50% - 44px / 2);
    margin-bottom: 24px;

    background: #ffffff;
    /* content/03 */

    border: 1px solid #b0bec5;
    border-radius: 22px;

    /* Inside auto layout */

    flex: none;
    order: 0;
    flex-grow: 1;
    margin: 16px 0px;
  }
  .buscar-empleado .form-control {
    border: 0px !important;
    font-family: Ubuntu !important;
    font-style: normal !important;
    font-weight: normal !important;
    font-size: 16px !important;
    line-height: 28px !important;
  }

  .card-header-left {
    /* Neutral / Gray blue light */
    background: #f5f5f5;
    /* Inside Auto Layout */
    flex: none;
    order: 0;
    align-self: stretch;
    flex-grow: 0;
    border-bottom: none;

    widows: 100%;
    border-top-left-radius: 8px !important;
    border-top-right-radius: 8px !important;
  }

  .card-header-text {
    /* Header Tablas */

    font-style: normal;
    //background: #F5F5F5;
    font-size: 16px;
    /* identical to box height */
    /* Alert/Succes */
    color: #263238 !important;
    width: 100%;
    border-top-left-radius: 8px !important;
    border-top-right-radius: 8px !important;
  }
  .card-personalizada {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 0px;
    position: static;
    background: #ffffff;
    border: 0px solid #eceff1 !important;
    box-sizing: border-box;
    box-shadow: 0px 6px 24px rgba(110, 116, 134, 0.2);
    border-radius: 12px !important;
    flex: none;
    order: 0;
    flex-grow: 0;
    //margin: 24px 0px;
  }

  select.custom-select {
    padding: 10px 10px;
    font-size: 15px;
    height: 50px;
    border-radius: 10px;
  }
  .table-views {
    box-shadow: 0px 6px 24px rgba(110, 116, 134, 0.2);
    border-radius: 8px;
    padding: 0;
    margin: 30px 5px;
    .t-head {
      background-color: #f5f5f5;
      padding: 5px 15px;
      text-align: left;
    }
    input {
      padding: 10px 10px;
      font-size: 15px;
      height: 50px;
      border-radius: 10px;
    }
    thead tr {
      background-color: #eef2fa;
      border-radius: 10px;
      text-align: left;
    }
    .theading {
      padding: 15px 15px;
    }
    tbody tr {
      border-radius: 10px;
    }
    tbody tr td {
      padding: 15px 15px;
      cursor: pointer;
    }
    tbody tr:hover {
      background-color: #f5f5f5;
    }
  }
}
</style>